import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * v2 · Empty state — dashed hairline box on surface, a 28px icon in
 * ink-faint, 15px ink-muted line, 13px ink-faint sub, then one quiet
 * action (raised pill or inline text). Never an accent button: an
 * empty state isn't a money moment.
 */
interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
}

function EmptyState({ icon, title, description, action, className, ...props }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-dashed border-hairline bg-surface p-[26px] text-center',
        className
      )}
      {...props}
    >
      {icon && <div className="flex justify-center text-ink-faint">{icon}</div>}
      <div className="mt-3 text-[15px] leading-[1.6] text-ink-muted">{title}</div>
      {description && <div className="mt-1.5 text-[13px] text-ink-faint">{description}</div>}
      {action && <div className="mt-3.5 flex justify-center">{action}</div>}
    </div>
  )
}

export { EmptyState }
